import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "d-flex align-items-center py-2" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_17 = { class: "col-2" }
const _hoisted_18 = { class: "badge text-outline-danger" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/liste-users",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, "Retour", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              (_ctx.user?.nomComplet)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("td", null, "Nom", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.user?.nomComplet), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user?.telephone)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Téléphone", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.user?.telephone), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Email", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.user?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user?.sexe)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Sexe", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.user?.sexe), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Caisses affectées", -1)),
                _createElementVNode("td", null, [
                  (_ctx.user?.affectations?.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.user.affectations.map(a => a.caisse.nom).join(', ')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "Aucune caisse affectée"))
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, "Rôle", -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData?.userRoles, (rle, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-6",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "bullet bg-primary me-3" }, null, -1)),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(rle?.role?.nom), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppRole(rle.id))
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Supprimer ", -1)
                              ]))], 8, _hoisted_19)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}